import { Tooltip } from '@mui/material';
import React from 'react';

import { ReactComponent as VisibilityIcon } from '../../../assets/svg/visibility_24px.svg';
import { ReactComponent as VisibilityOffIcon } from '../../../assets/svg/visibility_off_24px.svg';
import { Fa } from '../../elements/fa';
import styles from '../NewPointDetails.module.scss';

import { faSpinner } from '@fortawesome/fontawesome-free-solid';

export type PointDetailsActionsProps = {
    gotoStreet: () => void;
    onViewAsset: () => void;
    onViewDriver?: () => void;
    showDriverButton: boolean;
    directions: React.ReactNode;
    onTags: () => void;
    onTodayHistory: () => void;
    onLast30DayHistory: () => void;
    isCamera: boolean;
    check30DaysLeft: boolean;
    cameraStatus: string;
    showAlertHistoryVideo: () => void;
    loading: boolean;
    isEvent: boolean;
    alarmId?: string;
    onDownloadAlert: () => void;
    isDownloadingInProcess: boolean;
    onDownloadPoint: () => void;
    isDownloadStarted: boolean;
    isFailure: boolean;
    canHidePoints: boolean;
    isButtonHidden: boolean;
    onHidePoint: () => void;
    onShowPoint: () => void;
};

export const PointDetailsActions: React.FC<PointDetailsActionsProps> = ({
    gotoStreet,
    onViewAsset,
    onViewDriver,
    showDriverButton,
    directions,
    onTags,
    onTodayHistory,
    onLast30DayHistory,
    isCamera,
    check30DaysLeft,
    cameraStatus,
    showAlertHistoryVideo,
    loading,
    isEvent,
    alarmId,
    onDownloadAlert,
    isDownloadingInProcess,
    onDownloadPoint,
    isDownloadStarted,
    isFailure,
    canHidePoints,
    isButtonHidden,
    onHidePoint,
    onShowPoint
}) => (
    <div className={styles.PointDetailsBtns}>
        <div className={styles.PointDetailsButton} onClick={gotoStreet}>
            <span>Go To Street</span>
        </div>

        <div className={styles.PointDetailsButton} onClick={onViewAsset}>
            <span>View Asset</span>
        </div>

        {showDriverButton && onViewDriver && (
            <div className={styles.PointDetailsButton} onClick={onViewDriver}>
                <span>Go To Driver</span>
            </div>
        )}

        {directions}

        <div className={styles.PointDetailsButton} onClick={onTags}>
            <span>Tags</span>
        </div>

        <div className={styles.PointDetailsButton} onClick={onTodayHistory}>
            <span>Trip History</span>
        </div>

        <div className={styles.PointDetailsButton} onClick={onLast30DayHistory}>
            <span>30 Day History</span>
        </div>

        {isCamera && !check30DaysLeft && (
            <Tooltip title={cameraStatus} placement="top">
                <button
                    className={styles.PointDetailsButton}
                    onClick={() => showAlertHistoryVideo()}
                >
                    {loading ? <Fa icon={faSpinner} spin /> : <span>Play Video</span>}
                </button>
            </Tooltip>
        )}

        {isEvent && isCamera && !check30DaysLeft && alarmId && (
            <Tooltip title={'Download event'} placement="top">
                <button
                    className={styles.PointDetailsButton}
                    onClick={onDownloadAlert}
                >
                    {isDownloadingInProcess ? (
                        <Fa icon={faSpinner} spin />
                    ) : (
                        <span>Download event</span>
                    )}
                </button>
            </Tooltip>
        )}

        {!isEvent && isCamera && !check30DaysLeft && (
            <Tooltip title={'Download video'} placement="top">
                <button
                    className={styles.PointDetailsButton}
                    onClick={onDownloadPoint}
                    disabled={isFailure}
                >
                    {isDownloadingInProcess || isDownloadStarted ? (
                        <Fa icon={faSpinner} spin />
                    ) : (
                        <span>Download video</span>
                    )}
                </button>
            </Tooltip>
        )}

        {canHidePoints && !isButtonHidden && (
            <div className={styles.PointDetailsRedBtn}>
                <span
                    onClick={onHidePoint}
                    style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                >
                    <VisibilityOffIcon /> Hide
                </span>
            </div>
        )}

        {canHidePoints && isButtonHidden && (
            <div className={styles.PointDetailsButton}>
                <span
                    onClick={onShowPoint}
                    style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                >
                    <VisibilityIcon /> Show
                </span>
            </div>
        )}
    </div>
);